import type { Requisition } from '@core/types';

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function csvEscapeCell(v: string): string {
  if (/[,"\r\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

export function downloadRequisitionsCsv(rows: Requisition[]) {
  const headers = ['id', 'title', 'status', 'client', 'department', 'headcount', 'created_at'];
  const headerLine = headers.join(',');
  const lines = rows.map((r) => {
    const cells = [
      r.id,
      r.title ?? '',
      r.status ?? '',
      r.client?.name ?? '',
      r.department ?? '',
      r.headcount != null ? String(r.headcount) : '',
      r.created_at ?? '',
    ];
    return cells.map((x) => csvEscapeCell(String(x))).join(',');
  });
  const content = '\ufeff' + [headerLine, ...lines].join('\n');
  const stamp = new Date().toISOString().slice(0, 10);
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  triggerDownload(blob, `requisitions-${stamp}.csv`);
}
